import { createSlice } from "@reduxjs/toolkit";
import { GetAllBadge } from "store/middlewares/dataManagement/badge";

// isDeleteMeFulFilled
export const badgeSlice = createSlice({
  name: "badge",
  initialState: {
    badgeLoading: true,
    badge: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllBadge.pending, (state) => {
        state.badge = state.badge?.result?.length > 0 ? state.badge : null;
      })
      .addCase(GetAllBadge.fulfilled, (state, action) => {
        state.badgeLoading = false;
        state.badge = action.payload.response;
      })
      .addCase(GetAllBadge.rejected, (state) => {
        state.badgeLoading = false;
        state.badge = null;
      });
  },
});

export default badgeSlice.reducer;
